import type {ReactElement} from 'react';
import React, {useState} from 'react';
import styles from './free-bgr-mobile-notification.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {ClickableDiv} from '@Components/clickable-div';

export function FreeBgrMobileNotification(): ReactElement | null {
  const [isHidden, setIsHidden] = useState<boolean>(false);

  function closeNotification(): void {
    setIsHidden(true);
  }

  if (isHidden) {
    return null;
  }

  return (
    <ClickableDiv onClick={closeNotification} className={`flex-row-align-center radius-12 spacing-p-t-2 spacing-p-b-2 spacing-p-l-3 spacing-p-r-3 ${styles.container}`}>
      <Icon icon="icon-remove-bg" size={IconSize.SIZE_ICON_16} className="content-body-white spacing-m-r-1" />
      <Text val={window.i18next.t('pmwjs_free_bg_removal')} size={TextSize.XXSMALL} className="content-body-white" dangerouslySetInnerHTML />
    </ClickableDiv>
  );
}
